import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "redux-share";
import useBeforeUnload from "helpers/hooks/useBeforeUnload";
import useGetData from "helpers/hooks/useGetData/useGetData";
import { conditions, handleNotActiveText } from "helpers";
import { ConditionName } from "interfaces";
import { setIsFetchDetails, setIsValidAddress } from "redux-share/slices/videoDataSlice";
import { shallowEqual } from "react-redux";
import dynamic from "next/dynamic";

const VideoPlayer = dynamic(() => import("./videoPlayer"));
const NotActive = dynamic(() => import("../../player-components/notActive/notActive"));

const SplusPlayer = () => {
    const [notActiveText, setNotActiveText] = useState<any>(undefined);

    const dispatch = useAppDispatch();
    const { params, errorType } = useAppSelector(({ videoData: { params, errorType, details } }) => ({ params, errorType, details }), shallowEqual);

    useBeforeUnload();
    useGetData();

    useEffect(() => {
        if (!conditions(ConditionName.isValidAddress)) setNotActiveText(handleNotActiveText(errorType));
    }, [conditions(ConditionName.isValidAddress), errorType]);

    useEffect(() => {
        if (conditions(ConditionName.isGeneral)) {
            dispatch(setIsFetchDetails(true));
            dispatch(setIsValidAddress(true));
        }
    }, [conditions(ConditionName.isGeneral)]);

    return (
        <>
            {conditions(ConditionName.isFetchDetails) ? (
                conditions(ConditionName.isValidAddress) ? (
                    <div
                        className={`dvh ${!!params.height && params.height} ${
                            conditions(ConditionName.backgroundColorInLightMode) ? "pl-bg-white" : "pl-bg-dark-1"
                        } dark:pl-bg-dark-1`}
                    >
                        <VideoPlayer />
                    </div>
                ) : (
                    <div className={`pl-bg-white ${!!params.height ? params.height : "pl-h-screen"} pl-p-4`}>
                        <NotActive title={notActiveText.title} description={notActiveText.description} type={params.type!} />
                    </div>
                )
            ) : (
                <div className={`${!!params.height ? params.height : "pl-h-screen"} ${!!params.width ? params.width : "pl-h-screen"} pl-bg-black`} />
            )}
        </>
    );
};

export default SplusPlayer;
